import type { EditRowDef } from '../../../types'
import { buildFormDefaultValues } from '../../../helpers/buildFormDefaultValues'

export function buildEditFormInitialValues(
  rows: EditRowDef[]
): Record<string, unknown> {
  const editableRows = rows.filter((row) => row.mode === 'editable')
  const defaultValues = buildFormDefaultValues(
    editableRows.map((row) => row.field)
  )

  return editableRows.reduce<Record<string, unknown>>(
    (acc, row) => ({
      ...acc,
      [row.field.name]:
        row.initialValue !== undefined && row.initialValue !== null
          ? row.initialValue
          : defaultValues[row.field.name],
    }),
    {}
  )
}
